import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
export const StaticRouterMap = [{
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/register',
    hidden: true,
    component: () => import('@/views/login/register')
  },
  {
    path: '/otherRegister',
    name: 'otherRegister',
  
    hidden: true,
    component: () => import('@/views/login/otherRegister')
  },
  {
    path: '/qiyeRegister',
    name: 'qiyeRegister',
    hidden: true,
    component: () => import('@/views/login/qiyeRegister')
  },
  {
    path: '/moreIndex',
    name: 'moreIndex',
   
    hidden: true,
    component: () => import('@/views/login/moreIndex')
  },
  {
    path: '/smarunite/smaQueryUser',
    name: 'smarunite/smaQueryUser',
   
    hidden: true,
    component: () => import('@/views/login/jumpPage')
  },
  {
    path: '/ssoLogin',
    name: 'ssoLogin',
   
    hidden: true,
    component: () => import('@/views/login/ssoLogin')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: 'Dashboard',
    meta: {
      keepAlive: false,
      deepth: 1,
      title: '主页',
      icon: 'homeMenu'
    },
    children: [
      {
        path: 'dashboard',
        meta: { title: '主页', icon: 'homeMenu' },
        name: 'Dashboard',
        component: () => import('@/views/main/partMain/index'),

      },
      {
        path: 'userManageForm',
        name: 'userManageForm',
        hidden: true,
        meta: {
          title: '用户管理'
          
        },
        component: () => import('@/views/system/userManage/form')
      },
      {
        path: 'customs/check/checkDetail',
        name: 'checkDetail',
        hidden: true,
        meta: {
          title: '证书信息详情'
        },
        component: () => import('@/views/customs/check/detail')
      },
      {
        path: '/apply/cccmbsq/cccmbsqAddForm',
        name: 'applyForm',
        hidden: true,
        meta: {
          title: '新增申请',
          keepAlive:false
        },
        component: () => import('@/views/apply/cccmbsq/form')
      },
      {
        path: '/statisticsDetail',
        name: 'idStatisticsDetail',
        hidden: true,
        meta: {
          title: '账号统计'
        },
        component: () => import('@/views/statistics/cccmbIdStatistics/otherIndex')
      },
      {
        path: '/statisticsBusinessDetail',
        name: 'statisticsBusinessDetail',
        hidden: true,
        meta: {
          title: '业务办理统计'
        },
        component: () => import('@/views/statistics/cccmbBusiness/otherIndex')
      },
      {
        path: '/hsCodeIndex',
        name: 'hsCodeIndex',
        hidden: true,
        meta: {
          title: 'HSCode'
        },
        component: () => import('@/views/system/hsCode/index')
      },
      {
        path: '/scjgInfoIndex',
        name: 'scjgInfoIndex',
        hidden: true,
        meta: {
          title: '申请列表'
        },
        component: () => import('@/views/statistics/cccmbscjgcx/infoIndex')
      },
      {
        path: '/hsMaintainForm',
        name: 'hsMaintainForm',
        hidden: true,
        meta: {
          title: 'HS编码'
        },
        component: () => import('@/views/system/cccmbHSMaintain/form')
      },
      {
        path: '/hsMaintainChange',
        name: 'hsMaintainChange',
        hidden: true,
        meta: {
          title: 'HS编码'
        },
        component: () => import('@/views/system/cccmbHSMaintain/change')
      },
      {
        path: '/apply/cccmbsq/cccmbsqEditorForm',
        name: 'applyEditor',
        hidden: true,
        meta: {
          keepAlive: false, 
          title: '修改申请'
        },
        component: () => import('@/views/apply/cccmbsq/form')
      },
      {
        path: '/additional/cccfz/form',
        name: 'cccfzfrom',
        hidden: true,
        meta: {
          keepAlive: false, 
          deepth: 2,
          title: '证明信息补录页面'
        },
        component: () => import('@/views/additional/cccfz/form')
      },
      {
        path: '/additional/cccfzv/form',
        name: 'cccfzvfrom',
        hidden: true,
        meta: {
          keepAlive: false, 
          title: '证明信息详情'
        },
        component: () => import('@/views/additional/cccfzv/form')
      },
      {
        path: '/additional/cccfz/form',
        name: 'cccfzView',
        hidden: true,
        meta: {
          keepAlive: false, 
          title: '证明信息详情'
        },
        component: () => import('@/views/additional/cccfz/formv')
      },
      {
        path: 'cccmbzmcxDetail',
        name: 'cccmbzmcx',
        hidden: true,
        meta: {
          keepAlive: false, 
          title: 'CCC免办证明查询详情'
        },
        component: () => import('@/views/handle/cccmbzmcx/detail')
      },
      {
        path: '/apply/cccmbsq/cccmbsqUsage',
        name: 'applyUsage',
        hidden: true,
        meta: {
          title: '产品使用记录'
        },
        component: () => import('@/views/apply/cccmbsq/usage')
      },
      {
        path: 'applyindex',
        name: 'applyindex',
        meta: {
          title: '免办申请',
          keepAlive: true, 
        },
        hidden: true,
        component: () => import('@/views/apply/cccmbsq/index')
      },
      {
        path: '/apply/cccmbsq/cccmbsqDetails',
        name: 'mbsqDetails',
        meta: {
          title: '申请单详情'
        },
        hidden: true,
        component: () => import('@/views/apply/cccmbsq/details')
      },
      {
        path: '/handle/cccmbzmcx/detail',
        name: 'cccmbDetail',
        meta: {
          title: '申请单详情'
        },
        hidden: true,
        component: () => import('@/views/handle/cccmbzmcx/detail')
      },
      {
        path: '/handle/cccmbzmcx/detail',
        name: 'cccmbzmcxDetail',
        meta: {
          title: 'CCC免办证明查询详情'
        },
        hidden: true,
        component: () => import('@/views/handle/cccmbzmcx/detail')
      },
      {
        path: '/apply/cccmbsq/examine',
        name: 'cccmbdbsxExamine',
        meta: {
          title: 'CCC免办证明修改'
        },
        hidden: true,
        component: () => import('@/views/apply/cccmbsq/examine')
      },
      {
        path: '/handle/cccmbdbsx/examineOther',
        name: 'cccmbdbsxExamineOther',
        meta: {
          title: 'CCC免办待办事项'
        },
        hidden: true,
        component: () => import('@/views/handle/cccmbdbsx/examineOther')
      },
      {
        path: '/handle/cccmbdbsx/examineDetail',
        name: 'cccmbdbsxExamineDetail',
        meta: {
          title: 'CCC免办待办事项'
        },
        hidden: true,
        component: () => import('@/views/handle/cccmbdbsx/examineDetail')
      },
      {
        path: 'supervise/superviseManage/maintain',
        name: 'superviseManageTain',//Edit
        meta: {
          title: '后续监管管理',
          keepAlive:false
        },
        hidden: true,
        component: () => import('@/views/supervise/superviseManage/maintain')
      },
      {
        path: 'supervise/superviseManage/index',
        name: 'superviseManage',
        meta: {
          title: '后续监管管理查询',
          isCache: true, 
          isBack: false ,
          keepAlive:true
        },
        hidden: true,
        component: () => import('@/views/supervise/superviseManage/index')
      },
      {
        path: '/system/classaEnt/form',
        name: 'classaEntForm',
        meta: {
          title: '企业信息编辑'
        },
        hidden: true,
        component: () => import('@/views/system/classaEnt/form')
      },
      {
        path: '/system/classaEnt/classaAdd',
        name: 'classaEntAdd',
        meta: {
          title: '便捷企业设置'
        },
        hidden: true,
        component: () => import('@/views/system/classaEnt/classaAdd')
      },
      {
        path: '/system/classaEnt/classaDetail',
        name: 'classaEntDeatil',
        meta: {
          title: '便捷企业详情'
        },
        hidden: true,
        component: () => import('@/views/system/classaEnt/classaDetail')
      },
      {
        path: '/customs/customsfk/entryDetail',
        name: 'entryDetail',
        meta: {
          title: '通关单号详情'
        },
        hidden: true,
        component: () => import('@/views/customs/customsfk/entryDetail')
      },
      {
        path: '/basicOrg',
        name: 'basicOrg',
        meta: {
          title: '基层监管单位'
        },
        hidden: true,
        component: () => import('@/views/system/basicOrg/index')
      },
      {
        path: '/customs/customsfk/certDetail',
        name: 'certDetail',
        meta: {
          title: '证书号详情'
        },
        hidden: true,
        component: () => import('@/views/customs/customsfk/certDetail')
      },
      {
        path: '/customs/customsfk/certMDetail',
        name: 'certMDetail',
        meta: {
          title: '证书号详情'
        },
        hidden: true,
        component: () => import('@/views/customs/customsfk/certMDetail')
      },
      {
        path: '/system/classaEnt/detail',
        name: 'entDeatil',
        meta: {
          title: '企业详情'
        },
        hidden: true,
        component: () => import('@/views/system/classaEnt/detail')
      },
      {
        path: '/system/entUser/form',
        name: 'entUserForm',
        meta: {
          title: '企业账号编辑'
        },
        hidden: true,
        component: () => import('@/views/system/entUser/form')
      },
      {
        path: '/system/entUser/form',
        name: 'entUserAdd',
        meta: {
          title: '企业账号新增'
        },
        hidden: true,
        component: () => import('@/views/system/entUser/form')
      },
      // {
      //   path: '/redirect',
      //   component: Layout,
      //   name: 'redirect',
      //   hidden: true,
      //   children: [{
      //     path: '/redirect/:path*',
      //     component: () => import('@/views/redirect/index')
      //   }]
      // },
      {
        path: '404',
        name: 'error',
        component: () => import('@/views/404'),
        hidden: true
      },
    ]
  },

]


const createRouter = () =>
  new Router({
    scrollBehavior: () => ({
      y: 0
    }),
    routes: StaticRouterMap,
    mode:"history"/**url中的#去掉 */
  })

const router = createRouter()


export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
